import { hasAnalyticsConsent } from "./googleTag";

// Single source of truth for the first-party analytics session id, shared by
// useArticleAnalytics and useTrackView (previously duplicated with subtly
// different behaviour).
const SESSION_STORAGE_KEY = "bloxida_session_id";
let cachedSessionId: string | null = null;

/**
 * Returns a stable session id only when analytics consent is granted.
 *
 * Without consent it returns an ephemeral per-call id and actively clears any
 * cached/persisted id, so a previously-granted identifier never lingers or gets
 * reused after the user revokes consent. Persistence-symmetric with GA Consent
 * Mode: no first-party analytics identifier survives revocation.
 */
export function getAnalyticsSessionId(): string {
  if (!hasAnalyticsConsent()) {
    if (cachedSessionId) cachedSessionId = null;
    try {
      localStorage.removeItem(SESSION_STORAGE_KEY);
    } catch {
      /* storage unavailable */
    }
    return typeof crypto !== "undefined" && "randomUUID" in crypto
      ? `ephemeral-${crypto.randomUUID()}`
      : "ephemeral";
  }
  if (cachedSessionId) return cachedSessionId;
  try {
    let id = localStorage.getItem(SESSION_STORAGE_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(SESSION_STORAGE_KEY, id);
    }
    cachedSessionId = id;
    return id;
  } catch {
    cachedSessionId = "anon";
    return "anon";
  }
}
